import React from "react";
import { Box, Typography } from "@material-ui/core";

interface WarnMissingProps {
  title: string;
  fullWidth?: boolean;
}

export default function WarnMissing({ title, fullWidth = false, ...props }: WarnMissingProps) {

  return <Box p={1} mx={1} borderRadius="5px" border="1px solid #6B6B6Baa" bgcolor="#F5F5F5" width={fullWidth ? '100%' : 'auto'}>
    <Typography style={{ color: "#6B6B6Baa", textAlign: "center", fontSize: '1rem', fontWeight: "bold" }}>{title}</Typography>
  </Box>
}